export default "__VITE_ASSET__CM0cb6Q7__"